import { useState } from "react";
import { LoginBrandingPanel } from "../components/auth/LoginBrandingPanel";
import { LoginFormPanel } from "../components/auth/LoginFormPanel";
import { useAuth } from "../context/AuthContext";

export function LoginPage({ onCreateAccount, notice }) {
  const { login, loginError, launchError, isSubmitting, clearLoginError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  async function handleSubmit(event) {
    event.preventDefault();
    clearLoginError();
    try {
      await login(email, password);
    } catch {
      // loginError is set in AuthContext
    }
  }

  return (
    <div className="flex min-h-screen bg-white">
      <LoginBrandingPanel />
      <LoginFormPanel
        email={email}
        password={password}
        loginError={loginError}
        launchError={launchError}
        isSubmitting={isSubmitting}
        onEmailChange={(event) => setEmail(event.target.value)}
        onPasswordChange={(event) => setPassword(event.target.value)}
        onSubmit={handleSubmit}
        onCreateAccount={onCreateAccount}
        notice={notice}
      />
    </div>
  );
}
